module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACFSURBVHgB7ZXBDUBAEEX/ijt3ohA6UQkVUIlOKEQirjRgGIlkdx1kVyQO827zd3b+nP4AwgPKqNKixEbNoUbwY8SmWsx9dwmB8UxUvRjOZMf/RhfCWwMzDTF8SPIFiowFA3yMGIiBGIjBHwzMNCWsZ1xzKvoz6oV1D1RtNzjBC/LBEVzYAWaNGXpMiKJjAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/small-checkbox.png
// module id = 1067
// module chunks = 0